module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Chart-bar#3-5d55a29ab8fbaf6541a1af57590149f0.svg";